import {
  Component,
  ComponentRef,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  viewChild,
  ViewContainerRef,
} from '@angular/core';
import { CollapseItem } from '../../model/collapse.model';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'collapse-item',
  templateUrl: './collapse-item.component.html',
  styleUrls: ['./collapse-item.component.scss'],
  standalone: false,
})
export class CollapseItemComponent implements OnInit {
  @HostBinding('class') hostClass = '';
  vcr = viewChild('dynamicContainer', { read: ViewContainerRef });
  $container?: ComponentRef<any>;
  componentIsLoaded = false;

  @Input() collapseItem!: CollapseItem;
  @Input() isHtmlEditable = false;
  @Output() _onOpenItem = new EventEmitter<any>();
  @Output() _onCloseItem = new EventEmitter<any>();

  xCollapseItem!: CollapseItem;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.xCollapseItem = { ...this.collapseItem };
    this.hostClass = this.xCollapseItem.hostClass || '';
    this.xCollapseItem.isOpen && this.openContent();
  }

  toggleItem(collapseItem: CollapseItem) {
    this.xCollapseItem.isOpen = !collapseItem.isOpen;
    collapseItem.isOpen ? this.openContent() : this.closeContent();
  }

  openContent() {
    if (this.xCollapseItem.component && !this.componentIsLoaded) {
      if (!this.xCollapseItem.clearComponentOnClose) {
        this.componentIsLoaded = true;
      }

      this.$container = this.vcr()?.createComponent(this.xCollapseItem.component);
      const component = this.$container?.instance;
      component.data = this.xCollapseItem.data;
    }

    this._onOpenItem.emit(this.xCollapseItem);
  }

  sanitizedContent(content: string) {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }

  closeContent() {
    this.xCollapseItem.clearComponentOnClose && this.vcr()?.clear();

    this._onCloseItem.emit(this.xCollapseItem);
  }
}
